<script lang="ts">
  import LL, { locale } from '$i18n/i18n-svelte';
  import { getQueueTypeName } from '$lib/er/queue';
  import type { ResultOf } from '$lib/erar/api';
  import { trimTrailingZero } from '$lib/utils/number';

  export let playerId: number;
  export let partners: Promise<ResultOf<'GET /player/[id]/partners'>> | undefined;

  const summaryCutCount = 3;
  let showAll = false;
</script>

<section class="panel">
  <header>
    <h2>함께 한 플레이어</h2>
    <p>최근 200경기</p>
  </header>
  {#if partners}
    {#await partners}
      로딩 중...
    {:then partners}
      {@const players = partners.players}
      {@const partnerGroups = partners.result}
      <table cellspacing="0">
        <thead>
          <tr>
            <th>큐</th>
            <th style="width: 30%">그룹</th>
            <th>게임 수</th>
            <th>승률</th>
            <th>반타작률</th>
            <th>평균 킬</th>
          </tr>
        </thead>
        {#each partnerGroups.slice(0, showAll ? undefined : summaryCutCount) as partnerGroup}
          {@const memberWithoutMe = partnerGroup.group
            .filter((id) => id !== playerId)
            .map((memberId) => players[memberId])}
          <tr>
            <td>{getQueueTypeName($LL, partnerGroup.queueType)}</td>
            <td class="members">
              {#each memberWithoutMe as member}
                <div>
                  <span class="level">{member.level}</span>
                  <a class="name" href="/{$locale}/players/{member.name}">{member.name}</a>
                </div>
              {/each}
            </td>
            <td>{partnerGroup.plays}</td>
            <td>{trimTrailingZero((partnerGroup.wins / partnerGroup.plays) * 100, 1)}%</td>
            <td>{trimTrailingZero(partnerGroup.halfRate * 100, 1)}%</td>
            <td>{trimTrailingZero(partnerGroup.totalKills / partnerGroup.plays, 1)}</td>
          </tr>
        {/each}
      </table>
      {#if partnerGroups.length > summaryCutCount}
        <button class="show-all-button" on:click={() => (showAll = !showAll)}>
          {#if showAll}
            요약 보기
          {:else}
            모두 보기
          {/if}
        </button>
      {/if}
    {/await}
  {:else}
    표본이 충분하지 않습니다.
  {/if}
</section>

<style lang="postcss">
  .panel {
    display: flex;
    flex-direction: column;
    font-size: var(--size-5);
    align-items: stretch;
  }

  header {
    display: flex;
    align-items: center;
    p {
      font-size: var(--size-4);
      margin-left: auto;
      color: var(--text-dimmed);
    }
  }

  table {
    margin-top: var(--space-4);
  }

  .members {
    display: flex;
    flex-direction: column;
    gap: var(--space-2);

    div {
      display: flex;
      gap: var(--space-2);
      align-items: center;

      .level {
        border-radius: var(--radius-1);
        border: 1px solid var(--border-normal);
        padding: var(--space-1);
        font-size: var(--size-4);
      }
    }
  }

  td {
    padding: var(--space-2) var(--space-2);
    text-align: center;
  }

  tr:not(:last-child) td {
    border-bottom: 1px solid var(--border-normal);
  }

  .show-all-button {
    margin-top: var(--space-4);
  }
</style>
